import * as utils from '../utils.js';

class ShowReel {

  constructor(el) {

	  this.DOM = {};
	  this.DOM.el = el;
    this.DOM.body = document.body;
	  this.DOM.play = el.querySelector('.video--trigger');
	  this.DOM.close = el.querySelector('.video--close');
	  this.DOM.loop = el.querySelector('.video--cover');
	  this.DOM.player = el.querySelector('.video--player');
	  this.playing = false;

    this.init();
    this.addEvents();

  }

  init() {

    //console.log('New ShowReel');
    this.player = new Plyr(this.DOM.player);

  }

  addEvents() {
    
    this.DOM.loop.addEventListener('click', (e) => {

      e.preventDefault();
      this.DOM.el.classList.add('playing');
      this.DOM.body.classList.add('fullVideo');

      if (this.DOM.el.parentNode.parentNode.classList.contains('hero')) {
        TweenMax.to(window,1.2, {scrollTo:{y:0, autoKill:false}, ease:Power3.easeInOut, onComplete:() => {
          this.DOM.body.style.overflow = "hidden";
        }});
      } else {
        this.DOM.body.style.overflow = "hidden";
      }

      this.DOM.loop.pause();
      this.player.play();

    })

    this.DOM.play.addEventListener('click', (e) => {

      e.preventDefault();
      this.DOM.el.classList.add('playing');
      this.DOM.body.classList.add('fullVideo');

      if (this.DOM.el.parentNode.classList.contains('hero')) {
        TweenMax.to(window,1.2, {scrollTo:{y:0, autoKill:false}, ease:Power3.easeInOut, onComplete:() => {
          this.DOM.body.style.overflow = "hidden";
        }});
      } else {
        this.DOM.body.style.overflow = "hidden";
      }

      this.DOM.loop.pause();
      this.player.play();

    })

    this.DOM.close.addEventListener('click', (e) => {

      e.preventDefault();
      this.DOM.el.classList.remove('playing');
      this.DOM.body.classList.remove('fullVideo');

      this.DOM.loop.play();
      this.player.stop();

      if (!this.DOM.body.classList.contains('showMenu')) this.DOM.body.style.overflow = "";

    })

  }

}

export default ShowReel;
